import { Icon } from 'gu-ui-kit'
import React from 'react'
import format from 'utils/dateFns/format'
import { subWeeks } from 'date-fns'

const now = new Date()
const startDate = subWeeks(now, 2)

export default () => ({
  initial: {
    search: '',
    date_from: format(startDate, 'yyyy-MM-dd'),
    date_to: format(now, 'yyyy-MM-dd'),
    types: [],
    statuses: [],
  },
  configuration: {
    search: {
      subbutton: { isVisible: (value = '') => !!value },
      label: 'wallets::filters.input.placeholder',
      placeholder: 'wallets::filters.input.placeholder',
      order: 1,
      type: 'input',
    },
    types: {
      subbutton: {
        isVisible: (value = [], breakpoints) => value.length > 0 || !breakpoints.fb,
      },
      icon: (
        <Icon
          name={'avatar1'}
          size={'s'}
          bgColor={'Accent-Confirm-Secondary'}
          color={'Label-Onsurface'}
        />
      ),
      label: 'wallets::filters.dropdown.items.types.label',
      position: 'dropdown',
      type: 'checkbox group',
      optionLabelPrefix: 'wallets::filters.dropdown.items.types.options.',
      options: ['payment', 'partner_payment', 'award', 'transfer'],
    },
    statuses: {
      subbutton: {
        isVisible: (value = [], breakpoints) => value.length > 0 || !breakpoints.fb,
      },
      icon: (
        <Icon
          name={'avatar1'}
          size={'s'}
          bgColor={'Accent-Confirm-Secondary'}
          color={'Label-Onsurface'}
        />
      ),
      label: 'wallets::filters.dropdown.items.statuses.label',
      position: 'dropdown',
      type: 'checkbox group',
      optionLabelPrefix: 'wallets::filters.dropdown.items.statuses.options.',
      options: ['pending', 'success', 'declined', 'cancelled', 'error'],
    },
    datepicker: {
      names: ['date_from', 'date_to'],
      order: 2,
      subbutton: {
        // eslint-disable-next-line no-unused-vars
        isVisible: (value = [], breakpoints) => !breakpoints.md,
      },
      // @todo нужен общий лейбл а не в пульсе
      label: 'pulse::filters.range.label',
      type: 'datepicker',
    },
  },
})
